import { yupResolver } from "@hookform/resolvers/yup";
import { ChevronLeftIcon, EnterIcon } from "@radix-ui/react-icons";
import { Button, Card, Flex, Spinner } from "@radix-ui/themes";
import { useForm } from "react-hook-form";
import toast from "react-hot-toast";
import { useMutation } from "react-query";
import { useNavigate } from "react-router-dom";
import TextFieldComponent from "../../../components/inputs/Textfield/TextfieldComponent";
import { routes } from "../../../routes";
import { PaymentType } from "../../../types/Finance";
import { CreatePaymentTypeFormValidation } from "./CreatePaymentTypeFormValidation";
import { createPaymentType } from "../../../services/finance/paymentType";
import RadioGroupComponent from "../../../components/inputs/RadioGroup/RadioGroupComponent";
import SelectComponent from "../../../components/inputs/Select/SelectComponent";
import { internalCodes } from "../../../utils/codes";
import { useGetSchoolBankConfigQuery } from "../../../hooks/useGetSchoolBankConfigQuery";

export const CreatePaymentType = () => {
  const navigate = useNavigate();
  const mutation = useMutation({ mutationFn: createPaymentType, mutationKey: 'createPaymentType' });
  const { data: schoolBankConfigsData, status:schoolBankConfigsStatus } = useGetSchoolBankConfigQuery({ PageNumber: 1, PageSize: 400 });
  
  const defaultValues:PaymentType={
    description: "",
    amount: 10, 
    idRecurring: false, 
    internalCode:"",
  }
  const { control, handleSubmit, formState: { errors } } = useForm<PaymentType>
  (
    {
      resolver: yupResolver(CreatePaymentTypeFormValidation),
      defaultValues,
      mode: 'onBlur',
      reValidateMode: 'onBlur',
      shouldUseNativeValidation: false,
    }
  );
  const onSubmit = handleSubmit(async (data) => {
    try {
      data.idRecurring = Boolean(data.idRecurring);
      const result = await mutation.mutateAsync(data);
      if (result) {
        toast.success("Tipo de emolumento criado!");
        navigate(routes.paymentTypes);
      }
    } catch (err: any) {
      toast.error(`${mutation.error ?? err?.message}`);
    }
  });
  const handleBack = () => {
    navigate(routes.paymentTypes);
  }
  return (
    <form onSubmit={onSubmit} noValidate>
      <Card size='1'>
        <Flex direction='column' gap='4'>
          <TextFieldComponent name="description" label="Descrição" control={control} errors={errors} fieldProps={{ placeholder: 'Descrição' }} required={true}/>
          <Flex direction='row' gap='4'>
            <TextFieldComponent name="amount" label="Valor a pagar" control={control} style={{width:'100%'}} errors={errors} fieldProps={{ placeholder: 'Valor a pagar' }} />
            <SelectComponent
                name="internalCode"
                label="Código interno"
                required={true}
                control={control}
                errors={errors}
                style={{ width: '100%' }}
                options={internalCodes?.map(u => ({
                  value: u.id ?? "",
                  label: u.description ?? ""
                }))}
              />
            <TextFieldComponent name="day" label="Dia a cobrar" control={control} style={{width:'100%'}}  errors={errors} fieldProps={{ placeholder: 'Dia a cobrar' }} />
            <TextFieldComponent name="endDay" label="Dia de vencimento" control={control} style={{width:'100%'}}  errors={errors} fieldProps={{ placeholder: 'Dia de vencimento' }} />
          </Flex>
          <Flex direction='row' gap='4'>
            <SelectComponent
                name="preferedBank"
                label="Banco de preferência"
                required={true}
                control={control}
                errors={errors}
                style={{ width: '100%' }}
                options={schoolBankConfigsData?.items?.map(u => ({
                  value: u.id ?? "",
                  label: u.bankDescription ?? ""
                }))}
              />
          </Flex>
          <Flex direction='row' gap='4' style={{ alignSelf: 'end' }}>
            <Button type="button" variant="soft" color="gray" onClick={handleBack} disabled={mutation.isLoading}>
              <ChevronLeftIcon /> Voltar
            </Button>
            <Button type="submit" disabled={mutation.isLoading}>
              {mutation.isLoading ? <Spinner loading> <EnterIcon /></Spinner> : <EnterIcon />}
              Registar
            </Button>
          </Flex>
        </Flex>
      </Card>
    </form>
  );
}
